import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-loading',
  templateUrl: './status-loading.component.html',
  styleUrls: ['./status-loading.component.css']
})
export class StatusLoadingComponent implements OnInit {

  @Input()
  show: boolean;

  @Input()
  textColor = '#f6a608';

  @Input()
  text = 'Loading';

  styles = {
    color: '#f6a608'
  };

  ngOnInit(): void {
    if (this.textColor) {
      this.styles.color = this.textColor;
    }
  }

}
